export const favoriteConstants = {
  UPDATE_FAVORITE_FUNDS_QUERIES: 'UPDATE_FAVORITE_FUNDS_QUERIES',
  UPDATE_FAVORITE_FUNDS_TABLE_COLUMNS: 'UPDATE_FAVORITE_FUNDS_TABLE_COLUMNS',

  // Favorite Funds
  UPDATE_LOCAL_FAVORITE_FUNDS: 'UPDATE_LOCAL_FAVORITE_FUNDS',
  ADD_FAVORITE_FUND: 'ADD_FAVORITE_FUND',
  DELETE_FAVORITE_FUND: 'DELETE_FAVORITE_FUND',
  PUT_FAVORITE_FUNDS: 'PUT_FAVORITE_FUNDS',

  FETCH_FAVORITE_FUNDS_BY_ACCOUNT_START: 'FETCH_FAVORITE_FUNDS_BY_ACCOUNT_START',
  FETCH_FAVORITE_FUNDS_BY_ACCOUNT_SUCCESS: 'FETCH_FAVORITE_FUNDS_BY_ACCOUNT_SUCCESS',
  FETCH_FAVORITE_FUNDS_BY_ACCOUNT_FAILURE: 'FETCH_FAVORITE_FUNDS_BY_ACCOUNT_FAILURE',

  FETCH_NAV_FAVORITE_FUNDS_BY_ACCOUNT_START: 'FETCH_NAV_FAVORITE_FUNDS_BY_ACCOUNT_START',
  FETCH_NAV_FAVORITE_FUNDS_BY_ACCOUNT_SUCCESS: 'FETCH_NAV_FAVORITE_FUNDS_BY_ACCOUNT_SUCCESS',
  FETCH_NAV_FAVORITE_FUNDS_BY_ACCOUNT_FAILURE: 'FETCH_NAV_FAVORITE_FUNDS_BY_ACCOUNT_FAILURE',
  
  // Favorite Copyports
  FETCH_FAVORITE_COPYPORT_START: 'FETCH_FAVORITE_COPYPORT_START',
  FETCH_FAVORITE_COPYPORT_SUCCESS: 'FETCH_FAVORITE_COPYPORT_SUCCESS',
  FETCH_FAVORITE_COPYPORT_FAILURE: 'FETCH_FAVORITE_COPYPORT_FAILURE' 
};
